import Icon from 'components/Icon/Icon';
import { useSearchParams } from 'wouter';

const sortIconMap = {
  asc: 'arrow-down.outline',
  desc: 'arrow-up.outline',
  defaultIcon: 'arrows.outline',
} as const;

const getSortIconName = (sort: string | null) =>
  (sort && sortIconMap[sort as keyof typeof sortIconMap]) ??
  sortIconMap.defaultIcon;

const SortingIcon = () => {
  const [searchParams] = useSearchParams();
  const sort = searchParams.get('sort');

  return <Icon name={getSortIconName(sort)} height={16} width={16} />;
};

export default SortingIcon;
